import chalk from "chalk";

//#region colors.ts
const { white, gray, dim, hidden, bold, cyanBright, bgCyan } = chalk;
const brandColor = chalk.hex("#BD5B08");
const black = chalk.hex("#111");
const blue = chalk.hex("#0E838F");
const bgBlue = black.bgHex("#0E838F");
const red = chalk.hex("#AB2526");
const bgRed = black.bgHex("#AB2526");
const green = chalk.hex("#218529");
const bgGreen = black.bgHex("#218529");
const yellow = chalk.hex("#7F7322");
const bgYellow = black.bgHex("#7F7322");

//#endregion
export { bgBlue, bgCyan, bgGreen, bgRed, bgYellow, blue, bold, brandColor, cyanBright, dim, gray, green, hidden, red, white, yellow };